import baseRoute from './baseRoute';
import CoursePage from '@/views/CoursePage.vue';
import CourseHomePage from '@/views/course/CourseHomePage.vue';
import CourseElementPage from '@/views/course/CourseElementPage.vue';

export default (guards = null) =>
  baseRoute(
    {
      path: '/course',
      component: CoursePage,
      children: [
        {
          path: ':courseId',
          component: CourseHomePage,
          meta: {
            title: '{executingCourse}'
          },
          children: [
            {
              path: 'element/:elementId',
              component: CourseElementPage,
              meta: {
                title: '{executingCourse}'
              }
            }
          ]
        },
        {
          path: '*',
          redirect: '/home'
        }
      ]
    },
    guards
  );
